import { useNavigate } from "react-router-dom";
import "./PageLogin.scss";
import HeaderLine from '../../components/headerLine/HeaderLine';
import Infobox from '../../components/infobox/Infobox';
//import LoginForm from '../../components/loginForm/LoginForm';
import FormLogin from '../../components/forms/login/FormLogin';
import useMain from "../../common/MainContext";

export default function PageLogin(props) {
    const { loginData } = useMain();
    const navigate = useNavigate();

    if (loginData) {
        navigate('/home')
    }

    return (
        <div className="page-login fullpage">
            <HeaderLine
                selectedPage={"login"}
            />

            <main>
                <Infobox
                    info={<FormLogin />}
                />
            </main>
        </div>
    )
}
